var telugu$1 = {};

Object.defineProperty(telugu$1, "__esModule", {
  value: true
});
telugu$1.telugu = void 0;
// spec: https://www.unicode.org/charts/PDF/U0C00.pdf
var letter = "[\\u{0C00}-\\u{0C7F}]";
var trailingLetter = "[\\u{0C00}-\\u{0C04}\\u{0C3E}-\\u{0C56}\\u{0C62}\\u{0C63}]";
var control = "\\u{0C4D}"; // Virama

var telugu = "".concat(letter, "(").concat(control).concat(letter, "|").concat(trailingLetter, ")*");
telugu$1.telugu = telugu;

export { telugu$1 as t };
//# sourceMappingURL=telugu-DRXFXV9b.js.map
